import { Modal, Box, Grid, IconButton } from "@mui/material";
import GridCell from "components/BaseCell";
import CloseIcon from "@mui/icons-material/Close";
import { State } from "modules/shop_grid/types";
import { useTranslation } from "react-i18next";

const modalSx = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "90vh",
  overflow: "auto",
  boxSizing: "border-box",
  bgcolor: "background.paper",
  border: "1px solid #000",
  boxShadow: 24,
  p: 2,
  minWidth: "120px",
};

interface CellInventoryModalProps {
  sections: State.Section[];
  onClose: () => void;
}

const CellInventoryModal = ({ sections, onClose }: CellInventoryModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal open onClose={onClose}>
      <Box sx={modalSx}>
        <IconButton
          aria-label={t("a11y.closeModal")}
          onClick={onClose}
          sx={{ position: "absolute", top: "10px", right: "10px" }}
        >
          <CloseIcon />
        </IconButton>
        <Grid container sx={{ flexDirection: 'column' }}>
          {sections.map((section, indexSection) => (
            <Grid item xs={12} container key={indexSection}>
              {section.inventories.map((inventory, index) => (
                <Grid item key={index}>
                  <GridCell style={{ margin: 0.5 }} color={inventory.family?.color || ''}>{inventory.subFamily?.shortName || ''}</GridCell>
                </Grid>
              ))}
            </Grid>
          ))}
        </Grid>
      </Box>
    </Modal>
  );
};

export default CellInventoryModal;
